
function uvGetColor(type) {

  var colors =  {
    building: 'white',
    building_fill: '#009ee3',
    building_fill_done: '#78AB46',
    building_fill_reserved: '#ffed00',

    building_highlight: '#666',
    building_highlight_selected: '#E5007D',
    building_highlight_selected_fill: '#E5007D',

    building_analyze: '#FFF',
    building_analyze_fill_highest: '#39944A',
    building_analyze_fill_high: '#7FC97F',
    building_analyze_fill_low: '#FDAE61',
    building_analyze_fill_lowest: '#D7191C',
    building_analyze_fill_undefined: 'transparent',

    priority_area: '#FFF',
    priority_area_fill_highest: '#39944A',
    priority_area_fill_high: '#7FC97F',
    priority_area_fill_low: '#FDAE61',
    priority_area_fill_lowest: '#D7191C',
    priority_area_fill_undefined: 'transparent',
  };

  return colors[type];
}

window.uvGetColor = uvGetColor;
